import axios from "axios";
import { ENV_CONFIG } from '../constant';
import { getCurrentUserData, setCurrentUser } from './genericUtilities';
import { loginWithOuth } from "../sevices/account";


const axiosInstance = axios.create({
  baseURL: ENV_CONFIG.API_URL,

});



const WILD_CARD_APIS = [
  '/oauth/token',
]

let isRefreshing = false;
let failedQueue = [];

axiosInstance.interceptors.request.use(
  (config) => {

    if (WILD_CARD_APIS?.includes(config.url)) {
      return config;
    } else {
      const authTokens = getCurrentUserData();
      if (authTokens?.access_token) {
        config.headers.Authorization = `Bearer ${authTokens?.access_token}`
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    const authToken = getCurrentUserData();

    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      if (isRefreshing) {
        // If refresh is in progress, queue the request
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then((retryRequest) => {
          originalRequest.headers['Authorization'] = `Bearer ${getCurrentUserData().access_token}`;
          return axios(originalRequest);
        });
      }
      isRefreshing = true;
      try {

        const body = {
          refresh_token: authToken.refresh_token,
          client_id: ENV_CONFIG.CLIENT_ID,
          client_secret: ENV_CONFIG.CLIENT_SECRET,
          grant_type: "refresh_token"
        };

        const resp = await loginWithOuth(body);

        const newAccessToken = resp?.data?.access_token;


        setCurrentUser({ ...resp?.data });
        axiosInstance.defaults.headers['Authorization'] = `Bearer ${newAccessToken}`;
        failedQueue.forEach((req) => req.resolve());

        failedQueue = [];
        isRefreshing = false;

        originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
        return axios(originalRequest);


      } catch (refreshError) {
        // Handle refresh token failure
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }

    }

    return Promise.reject(error);
  }
);

export default axiosInstance